import { useState } from "react";
import { useCalendarStore } from "../../../hooks";
import Modal from "react-bootstrap/Modal";
import {
  ProfilePatient,
  EvaluationPatient,
  ResultEvaluationPatient,
  HistoryPatientSurgery,
  ValorationPatient,
} from "../";

export const ScheduledPatientModal = ({
  isOpen,
  setIsOpen,
  scheduleEventId,
}) => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    selectedPatientSurgery,

    // Methods
  } = useCalendarStore();

  // States ------------------------------------------------//
  const [activeIndex, setActiveIndex] = useState(1);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <Modal
      show={isOpen}
      onHide={() => setIsOpen(false)}
      centered
      size="xl"
      className="bg-light"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title">Información del paciente</h5>
      </Modal.Header>
      <Modal.Body>
        <ul className="nav nav-pills nav-justified flex-column flex-sm-row rounded shadow overflow-hidden bg-light">
          <li className="nav-item">
            <button
              className={`${
                activeIndex === 1 ? "active" : ""
              } nav-link rounded-0`}
              onClick={() => setActiveIndex(1)}
            >
              <div className="text-center pt-1 pb-1">
                <h5 className="mb-0">Perfil</h5>
              </div>
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`${
                activeIndex === 2 ? "active" : ""
              } nav-link rounded-0`}
              onClick={() => setActiveIndex(2)}
            >
              <div className="text-center pt-1 pb-1">
                <h5 className="mb-0">Historial</h5>
              </div>
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`${
                activeIndex === 3 ? "active" : ""
              } nav-link rounded-0`}
              onClick={() => setActiveIndex(3)}
            >
              <div className="text-center pt-1 pb-1">
                <h5 className="mb-0">Evaluación</h5>
              </div>
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`${
                activeIndex === 4 ? "active" : ""
              } nav-link rounded-0`}
              onClick={() => setActiveIndex(4)}
            >
              <div className="text-center pt-1 pb-1">
                <h5 className="mb-0">Resultados</h5>
              </div>
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`${
                activeIndex === 5 ? "active" : ""
              } nav-link rounded-0`}
              onClick={() => setActiveIndex(5)}
            >
              <div className="text-center pt-1 pb-1">
                <h5 className="mb-0">Valoración</h5>
              </div>
            </button>
          </li>
        </ul>

        {selectedPatientSurgery && (
          <div className="tab-content mt-4" id="pills-tabContent">
            {activeIndex === 1 && (
              <ProfilePatient patient={selectedPatientSurgery.patient} />
            )}
            {activeIndex === 2 && (
              <HistoryPatientSurgery
                patientId={selectedPatientSurgery.patient.id}
              />
            )}
            {activeIndex === 3 && (
              <EvaluationPatient
                evaluations={selectedPatientSurgery.evaluations}
                assessment={selectedPatientSurgery.procedure.assessment}
              />
            )}
            {activeIndex === 4 && (
              <ResultEvaluationPatient {...selectedPatientSurgery} />
            )}
            {activeIndex === 5 && (
              <ValorationPatient
                {...selectedPatientSurgery}
                scheduleEventId={scheduleEventId}
              />
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
